import { useState, useRef } from "react"
import HamburgerIcon from "../icons/hamburger-icon"
import useOutsideClick from "@/hooks/use-outside-click"

const HamburgerButton = ({ size, color, onClick, children }) => {
  const [open, setOpen] = useState(false)
  const ref = useRef(null) // 버튼 + 메뉴 전체를 감싸는 ref

  const handleClick = () => {
    setOpen((prev) => !prev)
    if (onClick) onClick(!open)
  }

  useOutsideClick({
    ref: ref,
    enabled: true,
    onOutside: () => setOpen(false)
  })

  return (
    <div className="relative flex" ref={ref}>
      <button onClick={handleClick}>
        <HamburgerIcon size={size} color={color} open={open} />
      </button>
      <div className="absolute top-full mt-2 right-0">{open && children}</div>
    </div>
  )
}

export default HamburgerButton
